import { Injectable } from '@angular/core';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})

export class Ga4Service {

  constructor() { }

  /**
   * Send a general event to GA4
   * @param eventName - The name of the GA4 event (e.g., 'add_to_cart')
   * @param eventParams - Object with event parameters
   */
  public sendEvent(eventName: string, eventParams: { [key: string]: any } = {}): void {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, eventParams);
    } else {
      console.warn('GA4 is not initialized');
    }
  }

  /**
   * Track a page view (SPA-friendly)
   */
  public sendPageView(path: string, title?: string): void {
    this.sendEvent('page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: title || document.title
    });
  }
}
